import { getFileIconByType, LocaleCodes } from '@mitchell/react.component.ux';
import { AttachmentType, EnterpriseDocStoreService, getMimeType, MimeTypeService, TranslationService } from "../../common";
import { QuestionnaireEnum } from '../enums';
export class Utilities {
    /**
     * Function to get the structure for the carousel componnet
     * @param files array of files to be shown
     */
    static getStructureForCarousel(files) {
        return files.map((file) => {
            return {
                id: Utilities.getUniqueId(),
                url: EnterpriseDocStoreService.createFileUrl(file.docUID || file.docId),
                thumbnailUrl: EnterpriseDocStoreService.createFileUrl(file.docUID || file.docId),
                fileType: getMimeType(MimeTypeService.lookup(file.fileName)),
                imageTitle: file.fileName,
                defaultIcon: getFileIconByType(MimeTypeService.lookup(file.fileName)),
                mimeType: MimeTypeService.lookup(file.fileName),
                thumbnailId: file.docUID,
                docuid: file.docUID || file.docId
            };
        });
    }
    /**
     * Function to generate structure for the attachment domain's payload
     * @param files  array of the files
     */
    static getStructureForAttachment(files) {
        return {
            attachments: files.map((file) => {
                return {
                    id: file.id,
                    description: null,
                    name: file.imageTitle,
                    referenceDocUuid: file.docuid,
                    size: 0,
                    type: AttachmentType.IMAGE
                };
            })
        };
    }
}
/**
 * Function to show validation message
 * @param mandatoryCondtnExpr flag to show message
 * @param answerList array of answers
 */
Utilities.shouldShowValidation = (mandatoryCondtnExpr, answerList) => {
    return mandatoryCondtnExpr &&
        answerList &&
        answerList.length > 0 &&
        (answerList[0].answerDisplayText === '' || answerList[0].answerDisplayText === null)
        ? true
        : false;
};
/**
 * Function to show validation message for yes no radio button
 * @param mandatoryCondtnExpr flag to show message
 * @param answerList array of answers
 */
Utilities.shouldShowValidationForYesNo = (mandatoryCondtnExpr, answerList) => {
    const areNoOptionsSelected = mandatoryCondtnExpr &&
        answerList &&
        answerList.length > 0 &&
        answerList.filter(answer => answer.answered === true).length === 0;
    return areNoOptionsSelected;
};
/**
 * Function to map the answer to question in multi choice question
 * @param answerList list of selected answer
 */
Utilities.mapQuestionnaireAnswerList = (answerList) => {
    return (answerList &&
        answerList.map(({ answerDisplayText }) => ({
            label: answerDisplayText,
            value: answerDisplayText
        })));
};
/**
 * Function to create the final object to be saved
 * @param questionnaireData the questionnaire object with the data
 */
Utilities.createSaveData = (questionnaireData) => {
    let unansweredQuestionCounter = 0;
    const saveData = [];
    let selectedComplexAnswerList = [];
    questionnaireData &&
        questionnaireData.map((questionData) => {
            questionData.answerList.map((answerData) => {
                if (questionData.answrControlType === QuestionnaireEnum.CHOICE_SELECTION) {
                    if (answerData.answered) {
                        selectedComplexAnswerList.push({
                            complexAnswerTxt: answerData.answerDisplayText,
                            additionalAnswerInfo: ''
                        });
                        /** check if same questionnaireQuestionId & selectedComplexAnswerList exists in saveData */
                        const filteredSaveData = saveData.filter((saveDataItem) => saveDataItem.qustnnrQustnId === questionData.qustnnreQustnId &&
                            saveDataItem.complexAnswerList === selectedComplexAnswerList);
                        if (filteredSaveData.length === 0) {
                            if (questionData.multiSelectAllowed) {
                                saveData.push({
                                    qustnnrQustnId: questionData.qustnnreQustnId,
                                    answer: null,
                                    complexAnswerList: selectedComplexAnswerList
                                });
                            }
                            else {
                                saveData.push({
                                    qustnnrQustnId: questionData.qustnnreQustnId,
                                    answer: answerData.answerDisplayText,
                                    complexAnswerList: null
                                });
                            }
                        }
                    }
                    else {
                        unansweredQuestionCounter++;
                    }
                }
                else {
                    answerData.answered &&
                        saveData.push({
                            qustnnrQustnId: questionData.qustnnreQustnId,
                            answer: answerData.answerDisplayText,
                            complexAnswerList: null
                        });
                }
            });
            if (questionData.answrControlType === QuestionnaireEnum.CHOICE_SELECTION &&
                unansweredQuestionCounter === questionData.answerList.length &&
                questionData.multiSelectAllowed) {
                saveData.push({
                    qustnnrQustnId: questionData.qustnnreQustnId,
                    answer: null,
                    complexAnswerList: [
                        {
                            complexAnswerTxt: '',
                            additionalAnswerInfo: ''
                        }
                    ]
                });
            }
            selectedComplexAnswerList = [];
            unansweredQuestionCounter = 0;
        });
    return saveData;
};
Utilities.getSelectedAnswer = (answerList) => {
    return (answerList && answerList.length > 0 && answerList[0].answerDisplayText) || '';
};
Utilities.getUniqueId = () => new Date().getMilliseconds() * Math.ceil(Math.random() * 1000);
Utilities.convertToLocale = (value) => {
    const currentLang = TranslationService.getCurrentLanguage().toLowerCase();
    let strigifiedValue = '';
    if (value) {
        strigifiedValue = parseInt(value)
            .toFixed(2)
            .toString(); // add 2 decimals after the value
        switch (currentLang) {
            case LocaleCodes.ES.toLowerCase():
            case LocaleCodes.ES_ES.toLowerCase():
            case LocaleCodes.DE_DE.toLowerCase():
            case LocaleCodes.IT_IT.toLowerCase():
                return strigifiedValue
                    .replace('.', '@')
                    .replace(/,/g, '.')
                    .replace('@', ',');
            case LocaleCodes.FR_CA.toLowerCase():
            case LocaleCodes.FR.toLowerCase():
            case LocaleCodes.FR_FR.toLowerCase():
                return strigifiedValue.replace(/,/g, ' ').replace('.', ',');
            case LocaleCodes.EN_US.toLowerCase():
            case LocaleCodes.EN_GB.toLowerCase():
            default:
                return strigifiedValue;
        }
    }
    return '';
};
//# sourceMappingURL=Utilities.js.map